export const GET_BUILDING_LIST_REQUEST = 'GET_BUILDING_LIST_REQUEST'
export const GET_BUILDING_LIST_SUCCESS = 'GET_BUILDING_LIST_SUCCESS'
export const GET_BUILDING_LIST_ERROR = 'GET_BUILDING_LIST_ERROR'
export const RESET_BUILDING_LIST = 'RESET_BUILDING_LIST'
export const SHOW_ADD_BUILDING = 'SHOW_ADD_BUILDING'
export const HIDE_ADD_BUILDING = 'HIDE_ADD_BUILDING'
